module.exports = __webpack_public_path__ + "static/media/apple.e7ce957f.svg";